import { render, staticRenderFns } from "./MerchantDropoff.vue?vue&type=template&id=3272e5b5&scoped=true&"
import script from "./MerchantDropoff.vue?vue&type=script&lang=js&"
export * from "./MerchantDropoff.vue?vue&type=script&lang=js&"
import style0 from "./MerchantDropoff.vue?vue&type=style&index=0&id=3272e5b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272e5b5",
  null
  
)

export default component.exports